import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import CustomModal from '../CustomModal';

const ConfirmModal = ({ show, onClose, onConfirm, message }) => {
  return (
    <CustomModal title="Confirm" open={show} handleClose={onClose}>
      <Typography sx={{ marginBottom: 3 }}>{message}</Typography>

      <Box sx={{ display: 'flex', justifyContent: 'end', gap: 2 }}>
        <Button variant="outlined" color="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" color="secondary" onClick={onConfirm}>
          Confirm
        </Button>
      </Box>
    </CustomModal>
  );
};

export default ConfirmModal;
